// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const contentScrolled = "Scrollable__contentScrolled__BAuDr";
export const customScroll = "Scrollable__customScroll__z9jja";
export const customScrollHandle = "Scrollable__customScrollHandle__A6NhJ";
export const customScrollbar = "Scrollable__customScrollbar__eoxwr";
export const customScrollbarShownAlways = "Scrollable__customScrollbarShownAlways__nUSiD";
export const fadeBottom = "Scrollable__fadeBottom__9F4WE";
export const fadeTop = "Scrollable__fadeTop__51PYQ";
export const flexBox = "Scrollable__flexBox__bzrWX";
export const flexBoxStyles = "Scrollable__flexBoxStyles__ygaTG";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const innerContainer = "Scrollable__innerContainer__C1hgg";
export const innerHandle = "Scrollable__innerHandle__s6CkV";
export const medium = "500";
export const outerContainer = "Scrollable__outerContainer__+Tm0q";
export const regular = "400";
export const sans = "'sans'";
export const scrollHandleDragged = "Scrollable__scrollHandleDragged__j3qqh";
export const semibold = "600";
export const serif = "'serif'";